import { call, put, takeEvery } from 'redux-saga/effects';
import { sagaActions } from './sagaActions';
import { Uchain } from '../redux/api/agent';
import {
    updateMyReportsList,
    updateMyReportsLoading,
    resetMyReportsState,
} from '../redux/reducers/reducerSlices/MyReportsReducer';

/**
 * Saga to fetch My Reports list from the sproDownloadMyReports API.
 *
 * Full payload shape (all optional except CRUDTYPE):
 * {
 *   CRUDTYPE: 'R',
 *   ID, CUID, IDWarehouse,
 *   ReportType, StartDate, EndDate,
 *   Type, ReportEmail, Status,
 *   CreatedBy, URL,
 *   pageNo, limit   ← client-side pagination controls
 * }
 *
 * Client-side pagination is applied after the full list is fetched because
 * the backend does not yet support server-side pagination.
 */
function* fetchMyReportsSaga(action) {
    try {
        yield put(updateMyReportsLoading(true));

        const { ...apiPayload } = action.payload || {};

        const response = yield call(Uchain.sproDownloadMyReports, {
            CRUDTYPE: 'S',
            ...apiPayload,
        });

        const {
            data = [],
            pageNo = 1,
            limit = 50,
            totalElements = 0,
            totalPages = 0,
            first = true,
            last = true,
        } = response || {};

        yield put(
            updateMyReportsList({
                data,
                pageNo,
                limit,
                totalElements,
                totalPages,
                first,
                last,
            })
        );
    } catch (error) {
        // On error reset to empty so the UI doesn't stay in a loading state
        yield put(
            updateMyReportsList({
                data: [],
                pageNo: 1,
                limit: 50,
                totalElements: 0,
                last: true,
                first: true,
            })
        );
    } finally {
        yield put(updateMyReportsLoading(false));
    }
}

function* resetMyReportsSaga() {
    try {
        yield put(resetMyReportsState());
    } catch (error) {
        // noop
    }
}

// ── Watcher exports ───────────────────────────────────────────────────────────

export function* fetchMyReportsWatcher() {
    yield takeEvery(sagaActions.FETCH_MY_REPORTS, fetchMyReportsSaga);
}

export function* resetMyReportsWatcher() {
    yield takeEvery(sagaActions.RESET_MY_REPORTS, resetMyReportsSaga);
}
